import React from "react";
import { Typography, Box } from "@mui/material";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import { assetIcons } from "../../../constants/assets";
import InlineSvg from "../inline-svg";

const OddsChip = ({
  odds,
  isMediumScreen,
  width = isMediumScreen ? 60 : "auto",
  px = 1.7,
  boxShadow = "-2px 0px 50px rgba(199, 133, 40, 0.9)",
  icon = assetIcons.upArrow,
}) => {
  return (
    <Typography
      sx={{
        bgcolor: darkColors.buttonTop,
        mt: isMediumScreen ? 2 : 0,
        color: "white",
        width: width,
        px: px,
        py: 0.4,
        borderRadius: 99,
        fontSize: fontSizes.heading3,
        fontWeight: 500,
        boxShadow: boxShadow, // Shadow
        display: "flex", // Make Typography a flex container
        alignItems: "center", // Center items vertically
        justifyContent: "center", // Center items horizontally
        gap: 0.5, // Add spacing between icon and odds
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "start",
        }}
      >
        <InlineSvg url={icon} sx={{ pb: 0.4 }} />
      </Box>
      {odds}
    </Typography>
  );
};

export default OddsChip;
